import { gql } from '@apollo/client';

export const AddOrganizationOwners = gql`
  mutation AddOrganizationOwners(
    $organizationCode: String!
    $emails: [String!]!
    $message: String
  ) {
    addOrganizationOwners(
      organizationCode: $organizationCode
      emails: $emails
      message: $message
    )
  }
`;
